import React, { Component } from 'react';
import ReactDom from 'react-dom';

import { Provider } from 'react-redux';
import { Route, Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';

import store from './store';
import ArchiveSearch from './components/archive-search';
import SiteSearch from './components/site-search';

const history = createBrowserHistory();

export default class ArchiveSearchRoot extends Component {
	componentDidMount() {
		let reactWrapper = document.querySelector( '.react-fallback' );

		if ( reactWrapper !== null ) {
			this.addWrapperClass( reactWrapper );
			setTimeout( this.addComponentClass, 800 );
		}
	}

	addWrapperClass( wrapper ) {
		if ( wrapper.classList !== null ) {
			wrapper.classList.add( 'visible' );
		} else {
			wrapper.className += ' ' + 'visible';
		}
	}

	addComponentClass() {
		let reactComponents = document.querySelector( '.react-component' );

		if ( reactComponents !== null ) {
			if ( reactComponents.classList !== null ) {
				reactComponents.classList.add( 'visible-delay' );
			} else {
				reactComponents.className += ' ' + 'visible-delay';
			}
		}
	}

	render() {
		return (<Provider store={ store }>
				<Router history={ history }>
					<switch>
						<Route path="/category/:categorySlug/" component={ ArchiveSearch } />
						<Route path="/search/:searchTerm?/" component={ SiteSearch } />
					</switch>
				</Router>
			</Provider>
		);
	}
}

var ArchiveSearchElement = document.getElementById( 'ArchiveSearchElement' );
if ( ArchiveSearchElement ) {
	ReactDom.render( <ArchiveSearchRoot />, ArchiveSearchElement );
}

var SearchPageElement = document.getElementById( 'search-page-wrap' );
if ( SearchPageElement ) {
	//ReactDom.render( <ArchiveSearchRoot />, SearchPageElement );
}